import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    root: {
        overflow: "scroll !important",
        height: "100%",
        "-ms-overflow-style": "none" /* IE and Edge */,
        scrollbarWidth: "none" /* Firefox */,
        /* Hide scrollbar for Chrome, Safari and Opera */
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
});
